import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

export const showToast = (type, message, options = {}) => {
  const defaultOptions = {
    position: 'top-right',
    autoClose: 3000,
    clearOnUrlChange: false,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    ...options,
  };

  switch (type) {
    case 'success':
      toast.success(message, defaultOptions);
      break;
    case 'error':
      toast.error(message, defaultOptions);
      break;
    case 'info':
      toast.info(message, defaultOptions);
      break;
    case 'warning':
      toast.warning(message, defaultOptions);
      break;
    default:
      toast(message, defaultOptions);
  }
};
